var crisisMessage = jq('.crisis-messaging');
if (crisisMessage.length) {
    jq('.crisis-messaging a[href="#"]').click(function(e){
        e.preventDefault();
        crisisMessage.addClass('hide');
    });
    var crisisMessageTimestamp = crisisMessage.data('timestamp');
    var crisisMessageCookieName = 'eqMajorAnnouncement';
    var crisisMessageCookie = Cookies.get(crisisMessageCookieName);
    if (crisisMessageCookie != crisisMessageTimestamp) {
        crisisMessage.removeClass('hide');
        Cookies.set(crisisMessageCookieName, crisisMessageTimestamp, {secure: true, domain: window.location.hostname, expires: 7 });
    }
}
        

jq(document).ready(function() {
    //AOS
    jq('.module-hands').each(function(){
        jq(this).attr('data-aos', 'fade-in');
        jq(this).attr('data-aos-offset', '460');
    });
    AOS.init({
        startEvent: 'load',
        disable: function() {
            var maxWidth = 767;
            return window.innerWidth < maxWidth;
        }
    });
    
    
    jq('.bootstrap-select .dropdown-menu li').each(function(){
        jq(this).attr('role', 'menuitem');
    });
    
});

var newsSlider = jq('#news-slider');
if (newsSlider.length) {
    newsSlider.slick({
        infinite: true,
        dots: true,
        appendDots: '.news-wrapper',
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 767,
            settings: {
                infinite: true,
                dots: true,
                arrows: false,
            }
        }]
    });
}

var eventsSlider = jq('#events-slider');
if (eventsSlider.length) {
    eventsSlider.slick({
        infinite: true,
        dots: true,
        appendDots: '.events-wrapper',
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 767,
            settings: {
                infinite: true,
                dots: true,
                arrows: false,
            }
        }]
    });
}

var gallerySlider = jq('.news-gallery-slider');
if (gallerySlider.length) {
    gallerySlider.slick({
        infinite: true,
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        cssEase: 'linear'
    });
}

//Stat Animation
var divStatsAnimate = jq('.stats-animate');
if (divStatsAnimate.length) {
    divStatsAnimate.each(function() {
        var animationComplete = false;
        var divStatWrapper = jq(this);
        jq(document).on('scroll', function(ev) {
            if (!animationComplete) {
                var scrollOffset = jq(document).scrollTop();
                var containerOffset = divStatWrapper.offset().top - window.innerHeight;
                if (scrollOffset > containerOffset) {
                    divStatWrapper.find('.stat').each(function() {
                        var statDiv = jq(this).find('.number'),
                        number = parseInt(statDiv.attr('data-number')),
                        value = statDiv.attr('data-value');
                        jq({num: 0}).stop(true).animate({num: number}, {
                            duration : 2000,
                            step: function () {
                                var numVal = Math.round(this.num);
                                statDiv.text(numVal);
                            }
                        }).promise().done(function () {
                            statDiv.text(value);
                        });
                    });
                    animationComplete = true;
                }
            }
        });
    });    
}